// extracted by mini-css-extract-plugin
export default {"mainContainer":"stockPage_mainContainer__1I-rw","innerContainer":"stockPage_innerContainer__LMAHC"};